//LIBRARY
import styled from "styled-components";
import Slider from "react-slick";

//MISC

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { COLORS, SIZE, BORDER_RADIUS, DEVICE_TYPE } from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const OfficialsCarouselContainer = styled.div`
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius32};
  margin: 40px 80px 60px 80px;
  padding: 40px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin: 24px 32px 100px 32px;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 40px 0px;
    margin: 24px 0px 0px 0px;
  }
`;

export const OfficialsSlider = styled(Slider)`
  .slick-slide {
    transition: transform 0.3s ease, opacity 0.3s ease;
    padding-inline: 12px;
  }
  .slick-prev,
  .slick-next {
    display: none !important;
  }
`;

export const OfficialsSliderItem = styled.div`
  aspect-ratio: 1/1.4;
  @media (max-width: 768px) {
    aspect-ratio: 1/1;
  }
`;

export const CarouselScrollbar = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -10px;
  padding-bottom: 10px;
`;

export const CarouselDot = styled.div`
  border-radius: 50%;
  height: ${SIZE.max8};
  width: 30%;
  display: flex;

  justify-content: space-between;

  & > li {
    height: 12px;
    width: 12px;
    background-color: ${COLORS.lineColor};
    transition: background-color 0.3s ease-out, border-radius 0.3s ease-out;
    border-radius: 50%;
  }
  & > li.slick-active {
    border-radius: 50%;
    height: 12px;
    width: 12px;
    background-color: ${COLORS.VividAuburn};
    transition: background-color 0.3s ease-out, border-radius 0.3s ease-out;
  }

  @media (width<550px) {
    width: 60%;
  }
`;

export const CarouselDotButton = styled.div`
  background-color: inherit;
`;

export const OfficialsCardContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: ${BORDER_RADIUS.radius32};
`;

export const OfficialsCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const NavButton = styled.button<{ available: boolean }>`
  background-color: transparent;
  border: none;
  padding: 10px;
  margin: 0 10px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  z-index: 2;
`;

export const LeftImgButton = styled.img`
  height: 24px;
  width: 15px;
  transform: rotate(90deg);
`;
export const RightImgButton = styled.img`
  height: 24px;
  width: 15px;
  transform: rotate(-90deg);
`;
export const HeaderComponent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0px 40px;
  }
`;

export const NavButtonsWrapper = styled.div``;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
  }
`;

export const ModalContentWrapper = styled.div`
  position: relative;
`;

export const ModalContent = styled.div`
  background: ${COLORS.RaisinBlack};
  padding: 20px;
  border-radius: ${BORDER_RADIUS.radius32};
  overflow: auto;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    background-color: transparent;
    padding: 0px;
    width: 100%;
    height: auto;
    border-radius: 0;
  }
`;

export const ImgModal = styled.img`
  border-radius: ${BORDER_RADIUS.radius32};
  height: 536px;
  width: auto;
  max-width: 1600px;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    height: auto;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 0;
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: -84px;
  right: 0px;
  background: ${COLORS.RaisinBlack};
  border-radius: ${BORDER_RADIUS.radius16};
  border: none;
  height: 64px;
  width: 64px;
  z-index: 1000;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    background-color: transparent;
  }
`;

export const XImg = styled.img`
  width: 32px;
  height: 32px;
`;
